module.exports = __webpack_public_path__ + "static/img/2_1_4.3f4a6cb4.jpg";